export enum AuthRoutes {
  LOGIN = 'login',
  REGISTER = 'register'
}
